import { FunctionComponent } from 'react'
import { IWorkroomExtended } from 'Frontend/scripts/models/workrooms.model'
import { useTranslation } from 'react-i18next'

interface IHiddenWorkroomProps {
  workroom: IWorkroomExtended
}

const HiddenWorkroom: FunctionComponent<IHiddenWorkroomProps> = ({ workroom }) => {
  const { t } = useTranslation()
  return (
    <li className="d-flex justify-content-between position-relative manage-forums__thread-item gap-2">
      <a className="manage-forums__thread-item-link" href={workroom.url}>
        {workroom.name}
      </a>
      <span className="badge workrooms__status workrooms__status--small">{t('hidden')}</span>
    </li>
  )
}

export default HiddenWorkroom
